/** Shared MUI sx for authenticated-shell page titles (matches `.qc-page-title`). */
export const qcPageTitleSx = {
  display: 'block',
  boxSizing: 'border-box' as const,
  width: '100%',
  maxWidth: 'none',
  margin: '0 0 var(--qc-page-title-margin-bottom, 16px)',
  marginTop: 0,
  marginLeft: 0,
  padding: 0,
  textAlign: 'left' as const,
  color: 'var(--qc-page-title-color, var(--qc-shell-copy, #020617))',
  fontFamily:
    'var(--qc-page-title-family, Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif)',
  fontSize: 'var(--qc-page-title-size, clamp(26px, 3.2vw, 32px))',
  fontWeight: 'var(--qc-page-title-weight, 700)' as const,
  letterSpacing: 'var(--qc-page-title-tracking, -0.025em)',
  lineHeight: 'var(--qc-page-title-line, 1.2)',
  background: 'transparent',
  backgroundImage: 'none',
  border: 0,
  borderRadius: 0,
  boxShadow: 'none',
};

/** Shared page body under route chrome (inset on .mainPanelPadded). */
export const qcPageShellSx = {
  boxSizing: 'border-box' as const,
  width: '100%',
  maxWidth: 'none',
  margin: 0,
  padding: 0,
  background: 'transparent',
  backgroundImage: 'none',
};

/**
 * Menu and submenu tab chrome for Lifetime Access and QuickLinks.
 * Spread onto the page wrapper, not onto a Tabs `sx` prop.
 */
export const qcMenuTabsSx = {
  '& .MuiTabs-flexContainer': { gap: '24px' },
  '& .MuiTabs-root .MuiTab-root': {
    color: 'var(--qc-shell-muted, #a9b5ca)',
    fontSize: { xs: 15, sm: 19 },
  },
  '& .MuiTabs-root .Mui-selected.MuiTab-root': {
    color: 'var(--qc-accent, #2a9dff)',
    fontWeight: 700,
    textDecoration: 'none',
  },
};

/** Home-matched surface card corners/colors for MUI sx. */
export const qcSurfaceCardSx = {
  border: '1px solid var(--qc-accent-line, rgba(91, 151, 255, 0.28))',
  borderRadius: 'var(--qc-radius-card, 20px)',
  color: 'var(--qc-card-copy, var(--qc-shell-copy, #f8f9ff))',
  bgcolor: 'var(--qc-card-surface, var(--qc-shell-surface, #071426))',
  backgroundImage: 'none',
  boxShadow: 'none',
};

/** Shared MUI sx for shell section titles (matches `.qc-section-title`). */
export const qcSectionTitleSx = {
  display: 'block',
  boxSizing: 'border-box' as const,
  margin: '0 0 var(--qc-section-title-margin-bottom, 12px)',
  padding: 0,
  textAlign: 'left' as const,
  textTransform: 'none' as const,
  color: 'var(--qc-section-title-color, var(--qc-shell-copy, #020617))',
  fontFamily:
    'var(--qc-section-title-family, Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif)',
  fontSize: 'var(--qc-section-title-size, 18px)',
  fontWeight: 'var(--qc-section-title-weight, 700)' as const,
  letterSpacing: 'var(--qc-section-title-tracking, -0.01em)',
  lineHeight: 'var(--qc-section-title-line, 1.3)',
};

/** Shared MUI sx for shell card/stat labels (matches `.qc-card-label`). */
export const qcCardLabelSx = {
  display: 'block',
  boxSizing: 'border-box' as const,
  margin: 0,
  padding: 0,
  textAlign: 'left' as const,
  textTransform: 'none' as const,
  color: 'var(--qc-card-label-color, var(--qc-shell-muted, #111827))',
  fontFamily:
    'var(--qc-card-label-family, Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif)',
  fontSize: 'var(--qc-card-label-size, 15px)',
  fontWeight: 'var(--qc-card-label-weight, 600)' as const,
  letterSpacing: 'var(--qc-card-label-tracking, 0)',
  lineHeight: 'var(--qc-card-label-line, 1.35)',
};
